<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import Url from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let sendType = {/*0:'自动发送',*/1:'定时发送'}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete"){
          this.dataChanage(Url.smsTemplate.delete,{id:row.id},res =>{
            this.$refs.childTable.defaultQueryData(this.queryData);
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.smsTemplate.edit,model,res => {
          this.$refs.childTable.defaultQueryData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error("suc");
          }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id', hidden:true},
            { title: '发送类别', field: 'sendType',type:2, optionList: sendType,isNumber: true,required:true},
            { title: '推送类别', field: 'pushType',required:true},
            { title: '短信内容', field: 'content',textType:"textarea",required:true},
            { title: '备注', field: 'remark'},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '发送类别', field: 'sendType',type:2, optionList: sendType,isNumber: true},
            { title: '推送类别', field: 'pushType'},
            {click:"查询",auth:"cfint:smstemplate:query"},
            {click:"新增",auth:"cfint:smstemplate:add"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.smsTemplate.list, //请求路径和参数
          sequence: true,
          isPage: false,
          cols: [
            { title: '发送类别', field: 'sendType',render: (data, full) => {
                return sendType[data];
              }},
            { title: '推送类别', field: 'pushType'},
            { title: '短信内容', field: 'content'},
            { title: '备注', field: 'remark'},
            { title: '更新人', field: 'updater'},
            { title: '更新时间', field: 'updateTime',render: (data, full) => {
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
            {title:"操作", btnClick: [
              { name: "修改", size: 'mini', click: 'update', type: 'primary' ,icon:"el-icon-update",auth:"cfint:smstemplate:update"},
              { name: "删除", size: 'mini', click: 'delete', type: 'primary' ,icon:"el-icon-delete",auth:"cfint:smstemplate:delete"}]
            }
          ]
        }
      }
    }
  }
</script>
